import { useCallback } from 'react'

import { Delete } from '@workwave-tidal/core/icons'
import { DownloadKML } from '@/icons'
import { resetCrudSelection } from '@/atoms'

import { useTexts } from './hooks/useTexts'
import { useBulkInfos } from './hooks/useBulkInfos'
import { useActions } from './hooks/useActions'

import { preview } from '@/components/form/preview'
import { ViewDetails } from '../../components/ViewDetails'

import { useDeleteRoadSegmentModal } from '../../../modals/DeleteRoadSegmentModal'

interface Props {
  roadSegments: uui.domain.client.rm.SegmentException[]
}

export function BulkView(props: Props) {
  const { roadSegments } = props

  const { mixed, title, malus, additionalDrivingTimeSec } = useBulkInfos(roadSegments)
  const texts = useTexts()
  const actions = useActions(roadSegments)
  const roadSegmentIds = roadSegments.map(s => s.id)

  const { Modal: DeleteRoadSegmentModal } = useDeleteRoadSegmentModal()

  const onReset = useCallback(() => {
    resetCrudSelection('routingSegments')
  }, [])

  return (
    <preview.Root
      applyPendingFitMapOnMount
      header={
        <preview.Header title={title} onClose={onReset} testId="roadSegments-readonly-header">
          <preview.ActionBar>
            <preview.ActionBarItem
              icon={<DownloadKML size={24} />}
              onClick={actions.onExport}
              label={texts.exportKML}
              tooltip={texts.exportKML}
              testId="setup-road-segment__exportkml"
              data-trackid="setup-road-segment__exportkml"
              disableWhenReadOnly={false}
            />
            <preview.ActionBarItem
              icon={<Delete />}
              onClick={actions.onDelete}
              label={texts.delete}
              tooltip={texts.delete}
              disableWhenReadOnly
              testId="setup-road-segment__delete"
              data-trackid="setup-road-segment__delete"
            />
          </preview.ActionBar>
        </preview.Header>
      }
    >
      <ViewDetails
        malus={malus}
        mixed={mixed}
        additionalDrivingTimeSec={additionalDrivingTimeSec}
      />

      <DeleteRoadSegmentModal roadSegments={roadSegmentIds} />
    </preview.Root>
  )
}
